module.exports = __webpack_public_path__ + "static/media/31.4ab8cc84.png";